import { Component, input } from '@angular/core';
import { EIconPath } from '../../../../../shared/enums/icons.enum';

@Component({
  selector: 'pp-point-fields-custom-field-description',
  templateUrl: './point-fields-custom-field-description.component.html',
  styleUrl: './point-fields-custom-field-description.component.scss',
  standalone: false,
})
export class PointFieldsCustomFieldDescriptionComponent {
  ppDescription = input<string>('');

  EIconPath = EIconPath;
}
